import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[(_vm.viewMode === 'chart')?_c('line-chart',{staticClass:"fill-height pb-0",attrs:{"type":"bar","height":220,"raw-data":_vm.accelerationZones,"chart-value-keys":[
      { key: _vm.$t('table_headers.decelerations'), type: 'bar'},
      { key: _vm.$t('table_headers.accelerations'), type: 'bar'}
    ],"plot-options":{
      bar: {
        borderRadius: 5,
        borderRadiusApplication: 'end',
        borderRadiusWhenStacked: 'all',
        horizontal: true,
        barHeight: '60%',
        columnWidth: '90%',
      }
    },"x-value":"key","grid":{ show: false },"xaxis":{
      categories: _vm.accelerationZones.map(function (stat) { return stat.label; }),
      tickPlacement: 'between',
      min: -_vm.maxValue,
      max: _vm.maxValue,
      axisBorder: { show: false },
      labels: {
        formatter: function(value) {
          return Math.round(Math.abs(value));
        }
      }
    },"tooltip":{
      x: {
        formatter: function(value) {
          return value;
        }
      },
      y: {
        formatter: function(value) {
          return Math.abs(value).toFixed(1) + ' m';
        }
      }
    },"stacked":true},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c(VCardTitle,{staticClass:"pa-6 d-flex justify-space-between"},[_c('div',{staticClass:"subtitle-2 grey--text text--grey-100"},[_vm._v(" "+_vm._s(_vm.$t("card_title.acceleration_distance_zone_breakdown"))+_vm._s(_vm.aggregation ? ": " + _vm.$t(("variables." + _vm.aggregation + ".long")) : '')+" ")]),(_vm.removable)?_c(VBtn,{staticStyle:{"pointer-events":"auto"},attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('remove')}}},[_c(VIcon,{attrs:{"small":""}},[_vm._v(" fal fa-times ")])],1):_c('visual-list-toggle',{attrs:{"value":_vm.viewMode},on:{"update:value":function($event){_vm.viewMode=$event}}})],1)]},proxy:true}],null,false,3033984593)}):(_vm.viewMode === 'table')?_c(VCard,{staticClass:"fill-height rounded-lg"},[_c(VCardTitle,{staticClass:"pa-6 d-flex justify-space-between"},[_c('div',{staticClass:"subtitle-2 grey--text text--grey-100"},[_vm._v(" "+_vm._s(_vm.$t("card_title.acceleration_distance_zone_breakdown"))+_vm._s(_vm.aggregation ? ": " + _vm.$t(("variables." + _vm.aggregation + ".long")) : '')+" ")]),_c('div',{staticClass:"d-flex align-center"},[(!_vm.removable)?_c('visual-list-toggle',{attrs:{"value":_vm.viewMode},on:{"update:value":function($event){_vm.viewMode=$event}}}):_vm._e()],1)]),_c(VDataTable,{attrs:{"headers":_vm.tableHeaders,"items":_vm.accelerationZones,"hide-default-footer":"","disable-pagination":"","items-per-page":-1,"fixed-header":"","dense":"","height":220},scopedSlots:_vm._u([{key:"item.Decelerations",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(Math.abs(item.Decelerations).toFixed(1))+" ")]}},{key:"item.Accelerations",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(item.Accelerations.toFixed(1))+" ")]}}])})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }